import GradientText from 'components/GradientText';
import { CTAForm } from '../Form/CTAForm';
import { LabelButton } from '../buttons/LabelButton/LabelButton';
import './formSections.css';

export const CTAFormSection = () => {
    return (
        <div className="container">
            <div className="feedback">
                <div className="feedback-left-side">
                    <LabelButton>GET IN TOUCH</LabelButton>
                    <div className="yields">
                        <GradientText size="middle" textColor="white">
                            Increase
                            <br /> <em>yields</em> with us
                        </GradientText>
                    </div>
                </div>
                <CTAForm />
            </div>
        </div>
    );
};
